import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as AppState from '../AppState';
import { AreaType, LocationOrigin, SearchType, UserLocation } from '../interfaces/interfaces';
import { fetchLocationViaDeviceBrowser } from '../utilities/locationUtils';

export function useGetUserSearch() {

	const setGsUserSearch = useSetRecoilState(AppState.gsUserSearch);
	const setGsUserSearchLocation = useSetRecoilState(AppState.gsUserSearchLocation);
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);

	const getLocationViaUrlState = async () => {

		const pathSegments = window.location.pathname.split('/');
		const locationStateArray = pathSegments[4].split(',');
		let newLocationFromUrl: UserLocation = { initialized: true, origin: LocationOrigin.UrlState, areaType: AreaType.Geopoint };
		switch (pathSegments[3]) {
			case ('geo'):
				newLocationFromUrl = {
					...newLocationFromUrl,
					initialized: true,
					areaType: AreaType.Geopoint,
					boundsElastic: {
						top_left: {
							lat: parseFloat(locationStateArray[0]),
							lon: parseFloat(locationStateArray[1])
						},
						bottom_right: {
							lat: parseFloat(locationStateArray[2]),
							lon: parseFloat(locationStateArray[3])
						}
					},
					zoomLevel: parseFloat(locationStateArray[4])

				};
				setGsUserSearchLocation(newLocationFromUrl);
				break;

			case ('center'):
				newLocationFromUrl = {
					...newLocationFromUrl,
					initialized: true,
					areaType: AreaType.Center,
					boundsElastic: undefined,
					centerMap: { lat: parseFloat(locationStateArray[0]), lng: parseFloat(locationStateArray[1]) },
					zoomLevel: parseFloat(locationStateArray[2])

				};
				setGsUserSearchLocation(newLocationFromUrl);
				break;
			case ('address'):
				setGsUserSearch({ searchType: SearchType.TextInput, currentAACValue: locationStateArray[0].replace('-', ' ') });
				break;
			case ('postal-code'):
				setGsUserSearch({ searchType: SearchType.TextInput, currentAACValue: locationStateArray[0].replace('-', ' ') });
				break;
			case ('city'):
				setGsUserSearch({ searchType: SearchType.TextInput, currentAACValue: locationStateArray[0].replace('-', ' ') });
				break;
			case ('county'):
				setGsUserSearch({ searchType: SearchType.TextInput, currentAACValue: locationStateArray[0].replace('-', ' ') });
				break;
			case ('state'):
				setGsUserSearch({ searchType: SearchType.TextInput, currentAACValue: locationStateArray[0].replace('-', ' ') + ', USA' });
				break;
			default:
		}
	};

	const getCurrentLocation = async () => {
		const currentLocation = await fetchLocationViaDeviceBrowser(gsIsMobile);
		setGsUserSearch({});
		setGsUserSearchLocation(currentLocation);
	};

	return [getLocationViaUrlState, getCurrentLocation] as const;
}